














import { Component, Vue, Prop } from 'vue-property-decorator';
import { ApprovalStatus } from '@/interfaces/server-data';

@Component({
  name: 'ApprovedByColumn'
})
export default class ApprovedByColumn extends Vue {
  @Prop({ type: String, required: false })
  status?: ApprovalStatus;

  @Prop({ type: String, required: false })
  approvedBy?: string;

  get isApprovedAutomatically(): boolean {
    return this.status === ApprovalStatus.APPROVED_AUTOMATICALLY;
  }

  get autoApprovedText(): string {
    return this.$t('approvedBy.autoApproved') as string;
  }
}
